// extracted by mini-css-extract-plugin
module.exports = {"btn":"FollowModal_style_btn__3raOU"};